import { Image, Video, FileText, File } from 'lucide-react';
import { FilterType } from './types';

/**
 * Formatiert Dateigröße in lesbares Format
 */
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};

/**
 * Bestimmt Icon basierend auf MIME-Type
 */
export const getFileIcon = (mimeType: string, className: string = "w-5 h-5 text-gray-400") => {
  if (mimeType.startsWith('image/')) return <Image className={className} />;
  if (mimeType.startsWith('video/')) return <Video className={className} />;
  if (mimeType.includes('pdf') || mimeType.includes('document')) return <FileText className={className} />;
  return <File className={className} />;
};

/**
 * Bestimmt Kategorie basierend auf MIME-Type
 */
export const getFileCategory = (mimeType: string): FilterType => {
  if (mimeType.startsWith('image/')) return 'images';
  if (mimeType.startsWith('video/')) return 'videos';
  return 'documents';
};

/**
 * Gibt das Label für einen Filter zurück
 */
export const getFilterLabel = (filter: FilterType): string => {
  switch (filter) {
    case 'all': return 'Alle Medien';
    case 'images': return 'Bilder';
    case 'videos': return 'Videos';
    case 'documents': return 'Dokumente';
    default: return 'Alle Medien';
  }
};

/**
 * Utility function to validate file name for editing
 */
export const validateFileName = (name: string): string | null => {
  const ALLOWED_NAME_CHARS = /^[a-zA-Z0-9äöüÄÖÜß._\-\s()]+$/;
  
  if (!name || name.trim().length === 0) {
    return 'Dateiname ist erforderlich';
  }

  if (name.length > 255) {
    return 'Dateiname zu lang (max. 255 Zeichen)';
  }

  if (!ALLOWED_NAME_CHARS.test(name)) {
    return 'Dateiname enthält ungültige Zeichen';
  }

  return null;
};
